import { render } from "./movservico-editar.vue?vue&type=template&id=43b7471e"
import script from "./movservico-editar.vue?vue&type=script&lang=js"
export * from "./movservico-editar.vue?vue&type=script&lang=js"

import "./movservico-editar.vue?vue&type=style&index=0&id=43b7471e&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__